import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./en.json";
import { LANG_CODES, RTL_CODES } from "./languages";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// English is bundled for instant first paint + fallback. All other languages
// are fetched (and AI-generated/cached) from the backend i18n pipeline.
i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en } },
    partialBundledLanguages: true,
    fallbackLng: "en",
    supportedLngs: LANG_CODES,
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "arca_lang",
      caches: ["localStorage"],
    },
    backend: {
      loadPath: `${BACKEND}/api/i18n/bundle/{{lng}}`,
    },
    react: { useSuspense: false },
  });

export function applyDir(lng) {
  const code = (lng || i18n.language || "en").split("-")[0];
  const dir = RTL_CODES.includes(code) ? "rtl" : "ltr";
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", code);
  }
  return dir;
}

applyDir(i18n.language);
i18n.on("languageChanged", applyDir);

export default i18n;
